module.exports = __webpack_public_path__ + "img/image-anousheh-ansari.a7c43220.webp";